import { useState, useEffect } from "react";
import { Container, Row, Col, Dropdown, NavDropdown, Form, FormControl, Badge } from "react-bootstrap"
import { CloseButton, Button, Table, InputGroup, OverlayTrigger, Popover, Spinner } from "react-bootstrap"
import { GoSearch } from "react-icons/go"
import AzioniProposte from "./AzioniProposte";
import { getPropostaColor } from '../../../Utilities/getBorderColor'
import { getStatusOrderProposta } from '../../../Utilities/getStatusOrder'
import { FiChevronLeft } from 'react-icons/fi'
import { statiProposta } from "../../../Utilities/statiElementEnum";
import { BsQuestionCircle } from "react-icons/bs"
import { PiFileCsv, PiFilePdf } from "react-icons/pi"; 
import { convertPropostaToCSV } from "../../../Utilities/covertToCSV";
import { jsPDF } from "jspdf";

const dayjs = require('dayjs');

export default function ProposteElenco(props) {
    const [titolo, setTitolo] = useState("")
    let [statoPropostaFilter, setStatoPropostaFilter] = useState("")
    let [areaFilter, setAreaFilter] = useState("")
    let [categoriaFilter, setCategoriaFilter] = useState("")
    const [proposte, setProposte] = useState([]);

    let aree = (props.comune && props.comune.impostazioniComune && props.comune.impostazioniComune.imcAreeUrbane && props.comune.impostazioniComune.imcAreeUrbane.aree_urbane) || ["Caricamento..."]
    
    useEffect(() => {
        if (props.loadingBilanci) return;

        if (!props.bilanci || props.bilanci.length === 0) {
            setProposte([]);
            return;
        }

        const bilancio = props.bilanci.find((el) => el.bilId === props.bilId);
        setProposte(bilancio?.proposte || []);
    }, [props.loadingBilanci, props.bilanci, props.bilId]);

    const categorie = [
        ...new Set([
            ...(props.comune?.impostazioniComune?.imcCategorieProposte?.categorie_proposte || []),
            ...proposte.flatMap((p) => p.proCategorie.categorie),
        ]),
    ].sort();

    const getProposte = () => {
        let ret = proposte

        if (statoPropostaFilter.length > 0)
            ret = ret.filter((pro) => pro.proStato === statoPropostaFilter)

        if (areaFilter.length > 0)
            ret = ret.filter((pro) => pro.proArea === areaFilter)

        if (categoriaFilter.length > 0)
            ret = ret.filter((pro) => pro.proCategorie.categorie.includes(categoriaFilter))

        if (titolo.length > 0)
            ret = ret.filter((pro => pro.proTitolo.toLowerCase().includes(titolo.toLowerCase())))

        return ret
    }

    const redirectToList = () => {
        props.setMostraTabella(true)
        props.setStatoPropostaFilter("")
        props.setAreaFilter("")
    }

    let filterByStatoProposta = (statoProposta) => { setStatoPropostaFilter(statoProposta) }
    let resetStatoProposta = () => { setStatoPropostaFilter("") }
    let filterByArea = (area) => { setAreaFilter(area) }
    let resetArea = () => { setAreaFilter("") }
    let filterByCategoria = (categoria) => { setCategoriaFilter(categoria) }
    let resetCategoria = () => { setCategoriaFilter("") }

    // Funzione per scaricare il CSV (Tabella)
    const handleDownloadReports = () => {
        const proposte = getProposte(); 
        const csvContent = convertPropostaToCSV(proposte, props.bilanci.filter(el => el.bilId === props.bilId)[0].bilTitolo); 
        const url = window.URL.createObjectURL(new Blob([csvContent])); 
        const link = document.createElement('a');
        const fileName = `Proposte_${props.bilanci.filter(el => el.bilId === props.bilId)[0].bilTitolo}_${dayjs(new Date()).format("DDMMYYHHmm")}.csv`;
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

   // 👈 NUOVA FUNZIONE: Esportazione in PDF della SINGOLA proposta
    const handleDownloadSingolaPropostaPDF = (proposta) => {
        const doc = new jsPDF("p", "mm", "a4");
        const pageWidth = doc.internal.pageSize.getWidth();

        // 1. IMPOSTAZIONI INIZIALI INTESTAZIONE
        const logoSize = 10; 
        const cornerMarginX = 8; 
        const cornerMarginY = 6; 
        const margin = 14; 
        
        const hasLogo = !!props.comune?.comStemmaFile;
        const textComuneX = hasLogo ? cornerMarginX + logoSize + 3 : cornerMarginX; 
        
        // Wrap del Nome del Comune
        doc.setFontSize(11);
        const nomeComune = props.comune?.comNome || '';
        const splitNomeComune = doc.splitTextToSize(nomeComune, pageWidth - textComuneX - margin);

        // Wrap del Titolo Proposta
        doc.setFontSize(18);
        const titoloProposta = proposta.proTitolo || "Dettaglio Proposta";
        const splitTitle = doc.splitTextToSize(titoloProposta, pageWidth - (margin * 2));

        // 👈 NUOVO SOTTOTITOLO (Modulo: Nome Iniziativa)
        const iniziativaNome = props.bilanci.find(el => el.bilId === props.bilId)?.bilTitolo || "Non specificato";
        const labelModulo = props.comune?.impostazioniComune?.imcLabelModuloBilanci || "Contesto / Iniziativa";
        const sottotitoloTesto = `${labelModulo}: ${iniziativaNome}`;
        
        doc.setFontSize(12);
        const splitSottotitolo = doc.splitTextToSize(sottotitoloTesto, pageWidth - (margin * 2));

        // 2. CALCOLO DINAMICO ALTEZZE E POSIZIONI
        const topElementHeight = hasLogo ? Math.max(logoSize, splitNomeComune.length * 5) : (splitNomeComune.length * 5);
        
        const titleStartY = cornerMarginY + topElementHeight + 10; // Posizione del titolo
        const subtitleStartY = titleStartY + (splitTitle.length * 7) + 2; // Posizione del sottotitolo
        
        const headerHeight = subtitleStartY + (splitSottotitolo.length * 5) + 2; // Altezza totale prima della linea blu

        // 3. DISEGNO LOGO E TESTO IN ALTO A SINISTRA
        if (hasLogo) {
            const ext = props.comune.comStemmaFilename?.split('.').pop().toUpperCase() === 'JPG' ? 'JPEG' : 'PNG';
            const stemmaDataUrl = `data:image/${ext.toLowerCase()};base64,${props.comune.comStemmaFile}`;
            doc.addImage(stemmaDataUrl, ext, cornerMarginX, cornerMarginY, logoSize, logoSize);
        }

        doc.setTextColor(0, 0, 0);
        
        // Nome del comune
        doc.setFontSize(11);
        doc.setFont(undefined, "normal");
        const textComuneY = hasLogo ? cornerMarginY + (logoSize / 2) - ((splitNomeComune.length - 1) * 2.5) + 1.5 : cornerMarginY + 4;
        doc.text(splitNomeComune, textComuneX, textComuneY);

        // 4. TITOLO E SOTTOTITOLO (Centrati)
        // Titolo
        doc.setFontSize(18);
        doc.setFont(undefined, "bold");
        doc.text(splitTitle, pageWidth / 2, titleStartY, { align: "center" });

        // Sottotitolo (Non in grassetto, più piccolo)
        doc.setFontSize(12);
        doc.setFont(undefined, "normal");
        doc.text(splitSottotitolo, pageWidth / 2, subtitleStartY, { align: "center" });

        // 5. CORPO DEL DOCUMENTO E LINEA DI SEPARAZIONE
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(11);

        doc.setDrawColor(3, 105, 161);
        doc.setLineWidth(0.5); 
        doc.line(margin, headerHeight, pageWidth - margin, headerHeight);

        let currentY = headerHeight + 10;

        // Funzione di controllo salto pagina
        const checkPageBreak = (neededSpace = 10) => {
            if (currentY + neededSpace > 275) {
                doc.addPage();
                currentY = 20;
            }
        };

        // Funzione per inserire una riga standard
        const addRow = (label, value) => {
            checkPageBreak(10);
            doc.setFont(undefined, "bold");
            doc.text(`${label}:`, margin, currentY);
            doc.setFont(undefined, "normal");
            
            const startValueX = 65; 
            const textLines = doc.splitTextToSize(String(value || "---"), pageWidth - startValueX - margin);
            doc.text(textLines, startValueX, currentY);
            currentY += (textLines.length * 6) + 2; 
        };

        // --- PRIMA RIGA: 3 COLONNE (Autore, Email, Inviata il) ---
        checkPageBreak(15);
        doc.setFontSize(11);
        
        // 1° Colonna: Autore
        doc.setFont(undefined, "bold");
        doc.text("Autore", margin, currentY);
        doc.setFont(undefined, "normal");
        doc.text(`${proposta.partecipante?.datiPartecipante?.dparNome || ''} ${proposta.partecipante?.datiPartecipante?.dparCognome || ''}`, margin, currentY + 5);
        
        // 2° Colonna: Email di contatto
        doc.setFont(undefined, "bold");
        doc.text("Email di contatto", 80, currentY);
        doc.setFont(undefined, "normal");
        const emailText = doc.splitTextToSize(proposta.proEmail || "---", 65);
        doc.text(emailText, 80, currentY + 5);
        
        // 3° Colonna: Inviata il
        doc.setFont(undefined, "bold");
        doc.text("Inviata il", 155, currentY);
        doc.setFont(undefined, "normal");
        doc.text(proposta.proDataInvio ? dayjs(proposta.proDataInvio).format('DD/MM/YYYY') : "---", 155, currentY + 5);
        
        currentY += 16; 

        // --- SECONDA RIGA: Associazione ---
        addRow("Associazione/Comitato", proposta.proAssociazione || "---");
        
        currentY += 5; 

        // --- BLOCCO CENTRALE: Dati Proposta ---
        addRow("Area Urbana", proposta.proArea);
        addRow("Categoria", proposta.proCategorie?.categorie?.join(", ") || "Nessuna");
        addRow("Descrizione", proposta.proDescrizione || "Nessuna descrizione inserita.");

        // Allegati
        let infoAllegati = "---";
        if (proposta.allegati && proposta.allegati.length > 0) {
            infoAllegati = proposta.allegati.map((all, index) => {
                const nomeDelFile = all.allNome || all.nomeFile || all.name || `Allegato_${index + 1}`;
                return `- ${nomeDelFile}`;
            }).join("\n");
        }
        addRow("Allegato/i", infoAllegati);

        currentY += 5; 

        // --- BLOCCO FINALE: Stato e Voti ---
        addRow("Data Pubblicazione", proposta.proDataPubblicazione ? dayjs(proposta.proDataPubblicazione).format('DD/MM/YYYY') : "In validazione / Non pubblicata");
        addRow("Stato Proposta", proposta.proStato);
        
        const votiTotali = proposta.proVotiOffline + (proposta.votiProposta?.length || 0);
        addRow("Voti Ricevuti", String(votiTotali));

        // RISPOSTA DEL COMUNE (Se presente)
        if (proposta.proRisposta && proposta.proRisposta.trim() !== "") {
            currentY += 4;
            addRow("Risposta Amministrazione", proposta.proRisposta);
        }

        // ESITO (Se è stata dichiarata vincitrice o rifiutata)
        if (proposta.proFlAmmessa || proposta.proStato === statiProposta.Vincitrice) {
            addRow("Esito", "Proposta dichiarata VINCITRICE");
        } else if (proposta.proStato === statiProposta.Rifiutata) {
            addRow("Esito", "Proposta RIFIUTATA");
        }

        // NOME FILE
        const safeFileName = splitTitle[0].replace(/[^a-z0-9]/gi, '_').substring(0, 30);
        doc.save(`Proposta_${safeFileName}.pdf`);
    };
    return (
        <>
            <Container className="p-0 px-md-4 py-md-0">
                <div className="d-flex justify-content-between">
                    <h2 className="title2">
                        Proposte per: {props.bilanci.filter(el => el.bilId === props.bilId)[0]?.bilTitolo}
                    </h2>
                    <OverlayTrigger trigger="click" rootClose placement="left"
                        overlay={
                            <Popover id="popover-contained" >
                                <Popover.Header as="h3">Aiuto:</Popover.Header>
                                <Popover.Body>
                                    Ecco tutte le proposte inviate per questo bilancio.
                                    <br /><br />
                                    Possibili <strong>stati</strong>:
                                    <ul>
                                        <li><strong>In validazione</strong>: proposta non visibile ai partecipanti</li>
                                        <li><strong>Rifiutata</strong>: proposta di cui è visualizzabile solo il titolo</li>
                                        <li><strong>Pubblicata</strong>: proposta visibile ai partecipanti</li>
                                        <li><strong>Vincitrice</strong>: proposta che è stata eletta come vincitrice</li>
                                    </ul>
                                    <br />
                                    Possibili <strong>azioni</strong>:
                                    <ul>
                                        <li><strong>Controlla</strong>: per rifiutare o pubblicare la proposta</li>
                                        <li><strong>Rispondi</strong>: per inserire la risposta del comune</li>
                                        <li><strong>Registra firme</strong>: per registrare le firme raccolte al di fuori della piattaforma</li>
                                    </ul>
                                </Popover.Body>
                            </Popover>
                        }
                    >
                        <div className="my-auto" style={{ cursor: "pointer" }} >
                            <BsQuestionCircle size="2em" className="my-auto" />
                        </div>
                    </OverlayTrigger>
                </div>
                
                <Row className="d-flex justify-content-between my-4">
                    <Col>
                        <Dropdown className="d-inline" autoClose="inside">
                            <Dropdown.Toggle id="dropdown-autoclose-outside">
                                <span className="px-5">Filtra</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <NavDropdown title="Stato" className="noChangeOnClick" drop="end" onSelect={filterByStatoProposta}>
                                    {Object.values(statiProposta).map((stato, index) => (
                                        <NavDropdown.Item key={index} eventKey={stato}>{stato}</NavDropdown.Item>
                                    ))}
                                </NavDropdown>
                                <NavDropdown title="Area" className="noChangeOnClick" drop="end" onSelect={filterByArea}>
                                    {aree.map((area, index) => (
                                        <NavDropdown.Item key={index} eventKey={area}>{area}</NavDropdown.Item>
                                    ))}
                                </NavDropdown>
                                <NavDropdown title="Categoria" className="noChangeOnClick" drop="end" onSelect={filterByCategoria}>
                                    {categorie.map((categoria, index) => (
                                        <NavDropdown.Item key={index} eventKey={categoria}>{categoria}</NavDropdown.Item>
                                    ))}
                                </NavDropdown>
                            </Dropdown.Menu>
                        </Dropdown>
                        
                        {statoPropostaFilter.length > 0 &&
                            <Form.Label className="mx-4 mt-2 mt-md-1 d-block">
                                Stato: <strong> {statoPropostaFilter}</strong>
                                <Badge bg="outline-danger"><CloseButton onClick={resetStatoProposta} /></Badge>
                            </Form.Label>
                        }
                        {areaFilter.length > 0 &&
                            <Form.Label className="mx-4 mt-2 mt-md-1 d-block">
                                Area: <strong> {areaFilter}</strong>
                                <Badge bg="outline-danger"><CloseButton onClick={resetArea} /></Badge>
                            </Form.Label>
                        }
                        {categoriaFilter.length > 0 &&
                            <Form.Label className="mx-4 mt-2 mt-md-1 d-block">
                                Categoria: <strong> {categoriaFilter}</strong>
                                <Badge bg="outline-danger"><CloseButton onClick={resetCategoria} /></Badge>
                            </Form.Label>
                        }
                    </Col>
                    
                    <Col xs={12} md={5} className="d-flex justify-content-end">
                        <InputGroup className="mt-2 mt-md-0" style={{ maxHeight: "1rem" }}>
                            <InputGroup.Text id="basic-addon1"><GoSearch /></InputGroup.Text>
                            <FormControl placeholder="Cerca titolo..." onChange={(ev) => { setTitolo(ev.target.value) }} />
                        </InputGroup>
                    </Col>
                    
                    <Col className="text-end mt-3 mt-md-0">
                        <Button onClick={handleDownloadReports} variant="primary" >
                            <PiFileCsv className="me-1" />
                            Esporta tabella in formato csv
                        </Button>
                    </Col>
                </Row>

                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>Titolo</th>
                            <th>Autore</th>
                            <th>Categorie</th>
                            <th className="text-center">Area</th>
                            <th className="text-center">Stato</th>
                            <th className="text-center">Voti</th>
                            <th className="text-center nowrap">Pubblicata il</th>
                            <th className="text-center">Azioni</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.loadingBilanci ? (
                            // 👇 SPINNER SISTEMATO: ora è il classico cerchio nero/scuro
                            <tr>
                                <td colSpan={8} className="text-center py-5">
                                    <Spinner animation="border" variant="dark" role="status">
                                        <span className="visually-hidden">Caricamento...</span>
                                    </Spinner>
                                </td>
                            </tr>
                        ) : (
                            getProposte().length > 0 ? (
                                getProposte()
                                    .sort((a, b) => getStatusOrderProposta(a.proStato) - getStatusOrderProposta(b.proStato))
                                    .map(proposta => (
                                        <tr key={proposta.proId}>
                                            <td>{proposta.proTitolo}</td>
                                            <td>{proposta.partecipante?.datiPartecipante?.dparNome} {proposta.partecipante?.datiPartecipante?.dparCognome}</td>
                                            <td>{proposta.proCategorie?.categorie?.join(", ")}</td>
                                            <td className="text-center">{proposta.proArea}</td>
                                            <td className="text-center">
                                                <Badge pill bg={getPropostaColor(proposta)} className="pillText" style={{ minWidth: "90%" }}>
                                                    {proposta.proStato}
                                                </Badge>
                                            </td>
                                            <td className="text-center">{proposta.proVotiOffline + (proposta.votiProposta?.length || 0)}</td>
                                            <td className="text-center">
                                                {proposta.proDataPubblicazione ? dayjs(proposta.proDataPubblicazione).format('DD/MM/YYYY') : "---"}
                                            </td>
                                            <td>
                                                <div className="d-flex justify-content-center align-items-center gap-2">
                                                    <AzioniProposte
                                                        stato={proposta.proStato}
                                                        setGestisci={props.setGestisci}
                                                        setGestisciProposta={props.setGestisciProposta}
                                                        proposta={proposta}
                                                        setProposta={props.setProposta}
                                                        setLoadingBilanci={props.setLoadingBilanci}
                                                        loadingBilanci={props.loadingBilanci}
                                                    />
                                                    <Button 
                                                        variant="outline-danger" 
                                                        size="sm" 
                                                        title="Scarica PDF di questa proposta"
                                                        onClick={() => handleDownloadSingolaPropostaPDF(proposta)}
                                                    >
                                                        <PiFilePdf size="1.2em" />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                            ) : (
                                <tr>
                                    <td colSpan={8} className="text-center">
                                        Nessuna proposta trovata
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </Table>

                <Row>
                    <Container className="d-flex justify-content-between p-0 m-0 mt-4 mb-5">
                        <Button variant="outline-dark" onClick={redirectToList}>
                            <FiChevronLeft /> Indietro
                        </Button>
                    </Container>
                </Row>
            </Container>
        </>
    )
}